module.exports = __webpack_public_path__ + "media/asset/images/TokyoGAS/ITRI_company_team_Nissay-cb3f4eeb49cbd3d74528b130fd06d157.png";